import { ValoriSezione } from '@framework/api-client';
import {
  applyTreeTranslationKeys,
  IEngineSection,
  IRootWidget,
} from '@framework/engine';
import { cloneDeep } from 'lodash';
import { useMemo } from 'react';
import { IFrontOfficeModule } from '../../hooks/useModule';

/**
 * Hook che ritorna una versione strutturata delle sezioni
 */
export function useSections(input: IFrontOfficeModule) {
  const sections = useMemo(() => {
    return input.sezioni
      .map(section => {
        if (!section.sezione?.id) return null;

        const root = cloneDeep(
          section.sezione?.ultimaVersione?.elementi,
        ) as IRootWidget;

        if (section.sezione.ultimaVersione?.traduzioni) {
          applyTreeTranslationKeys(
            root,
            section.sezione.ultimaVersione?.traduzioni,
          );
        }
        const item: IEngineSection = {
          id: section.sezione.id,
          ultimaVersione: {
            ...section.sezione.ultimaVersione,
            elementi: root,
            visibile: section.regoleAbilitazione?.visible,
            compilabile: section.regoleAbilitazione?.enabled,
          },
          name: section.sezione.ultimaVersione?.nome ?? '',
        };
        return item;
      })
      .filter(Boolean) as IEngineSection[];
  }, [input]);

  const values = useMemo<ValoriSezione[]>(
    () => (input.valori ?? []) as ValoriSezione[],
    [input],
  );

  return { sections, values };
}

type IUseSections = ReturnType<typeof useSections>;
export type ISections = IUseSections['sections'];
